module.exports = __webpack_public_path__ + "static/Fleet-Auto-News-Logo-939f320fd5687b9249bad75c8f9a6e17.png";